"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserPlatformAPI = void 0;
const app_1 = require("@hexelate/app");
const browserNameTestCases = [
    { name: 'Edge', test: (ua) => ua.toLowerCase().includes('edg') },
    { name: 'Opera', test: (ua) => ua.toLowerCase().includes('opr')
            && Boolean(window.opr) },
    { name: 'Google Chrome', test: (ua) => ua.toLowerCase().includes('chrome')
            && Boolean(window.chrome) },
    { name: 'Internet Explorer', test: (ua) => ua.toLowerCase().includes('trident') },
    { name: 'Firefox', test: (ua) => ua.toLowerCase().includes('firefox') },
    { name: 'Safari', test: (ua) => ua.toLowerCase().includes('safari') },
];
const getBrowserInfo = (0, app_1.once)(() => {
    const nav = window.navigator;
    if (nav.userAgentData && nav.userAgentData.brands.length) {
        const { brand, version } = nav.userAgentData.brands[0];
        return { name: brand, version };
    }
    return [...nav.userAgent.matchAll(/[^\s]+\/[^\s]+/g)]
        .map(([match]) => match.split('/'))
        .map(([name, version]) => ({ name, version }))
        .find(({ name }) => Boolean(browserNameTestCases.find(({ test }) => test(name))))
        || { name: 'Unknown', version: 'Unknown' };
});
const openFile = () => {
    return new Promise((resolve, reject) => {
        const unmountedInput = document.createElement('input');
        unmountedInput.type = 'file';
        // unmountedInputElement.accept = '*'
        unmountedInput.addEventListener('change', (event) => {
            const file = event.target.files?.[0];
            if (!file)
                return;
            const reader = new FileReader();
            reader.onload = () => resolve({ file, contents: reader.result });
            reader.onerror = reject;
            reader.readAsText(file);
        });
        unmountedInput.dispatchEvent(new MouseEvent('click'));
    });
};
class BrowserPlatformAPI {
    _onProjectOpened = () => { };
    getPlatformInfo = () => {
        const browserInfo = getBrowserInfo();
        return {
            browserName: browserInfo.name,
            browserVersion: browserInfo.version,
        };
    };
    onOpenProject = (handler) => {
        this._onProjectOpened = handler;
    };
    requestOpenProject = async () => {
        const { file, contents } = await openFile();
        this._onProjectOpened(JSON.parse(contents), file.name);
    };
    requestSave = (project, filePath) => {
        const unmountedAnchor = document.createElement('a');
        const projectBlob = new Blob([JSON.stringify(project)], { type: 'text/obj' });
        unmountedAnchor.download = filePath || 'project.hx.json';
        unmountedAnchor.href = window.URL.createObjectURL(projectBlob);
        unmountedAnchor.dataset.downloadurl = ['text/obj', unmountedAnchor.download, unmountedAnchor.href].join(':');
        unmountedAnchor.dispatchEvent(new MouseEvent('click'));
    };
    quit = () => window.close();
}
exports.BrowserPlatformAPI = BrowserPlatformAPI;
